if (!customElements.get('test-results')) {
  class TestResults extends HTMLElement {
    constructor() {
      super();

      this.customSelect = this.querySelector('custom-select');
      this.previewsContainer = this.querySelector('[data-previews]');
      this.previews = this.querySelectorAll('[data-preview]');
      this.cta = this.querySelector('.test-results__cta a');
      this.breakpoint = window.matchMedia('(min-width: 750px)');
      this.onSelectChange = this.handleSelectChange.bind(this);
    }

    connectedCallback() {
      this.customSelect.addEventListener('change', this.onSelectChange);
      this.initSlider();
    }

    disconnectedCallback() {
      this.customSelect.removeEventListener('change', this.onSelectChange);
    }

    initSlider() {
      this.swiper = new Swiper(this.previewsContainer.firstElementChild, {
        effect: 'fade',
        speed: 600,
        slidesPerView: 1,
        allowTouchMove: false,
        watchOverflow: false,
      });
    }

    destroySlider() {
      this.swiper?.destroy(true, true);
    }

    handleSelectChange(e) {
      e.preventDefault();
      const index = e.detail.selectedIndex;

      this.swiper?.slideTo(index);

      const timeline = gsap.timeline({
        onComplete: () => timeline.revert(),
      });

      if (this.cta) {
        const newURL = this.cta.dataset[`url-${index}`];
        this.cta.href = newURL;
      }
    }
  }

  customElements.define('test-results', TestResults);
}
